/* Cooper & James theme behaviour */
(function () {
  'use strict';

  /* ---------- VAT toggle (remembered per shopper) ---------- */
  var VAT_KEY = 'cj-vat';
  function getVat() {
    try { return localStorage.getItem(VAT_KEY) === 'inc' ? 'inc' : 'ex'; } catch (e) { return 'ex'; }
  }
  function setVat(mode) {
    document.documentElement.setAttribute('data-vat', mode);
    try { localStorage.setItem(VAT_KEY, mode); } catch (e) {}
    document.querySelectorAll('[data-cj-vat]').forEach(function (btn) {
      btn.setAttribute('aria-pressed', btn.getAttribute('data-cj-vat') === mode ? 'true' : 'false');
    });
    document.dispatchEvent(new CustomEvent('cj:vat', { detail: mode }));
  }
  document.documentElement.setAttribute('data-vat', getVat());
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cj-vat]');
    if (btn) setVat(btn.getAttribute('data-cj-vat'));
  });

  /* ---------- Mega menu ---------- */
  function initMega() {
    var header = document.querySelector('[data-cj-header]');
    if (!header) return;
    var toggles = header.querySelectorAll('[data-cj-mega-toggle]');
    var closeTimer;
    function closeAll(except) {
      toggles.forEach(function (t) {
        if (t === except) return;
        t.setAttribute('aria-expanded', 'false');
        var panel = document.getElementById(t.getAttribute('aria-controls'));
        if (panel) panel.hidden = true;
      });
    }
    function open(t) {
      closeAll(t);
      t.setAttribute('aria-expanded', 'true');
      var panel = document.getElementById(t.getAttribute('aria-controls'));
      if (panel) panel.hidden = false;
    }
    toggles.forEach(function (t) {
      var panel = document.getElementById(t.getAttribute('aria-controls'));
      t.addEventListener('click', function () {
        if (t.getAttribute('aria-expanded') === 'true') closeAll(); else open(t);
      });
      if (window.matchMedia('(hover: hover)').matches) {
        t.addEventListener('mouseenter', function () { clearTimeout(closeTimer); open(t); });
        [t, panel].forEach(function (el) {
          if (!el) return;
          el.addEventListener('mouseleave', function () { closeTimer = setTimeout(closeAll, 180); });
          el.addEventListener('mouseenter', function () { clearTimeout(closeTimer); });
        });
      }
    });
    document.addEventListener('click', function (e) { if (!header.contains(e.target)) closeAll(); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        var openT = header.querySelector('[data-cj-mega-toggle][aria-expanded="true"]');
        closeAll();
        if (openT) openT.focus();
      }
    });
  }

  /* ---------- Mobile drawer ---------- */
  function initDrawer() {
    var drawer = document.querySelector('[data-cj-drawer]');
    var opener = document.querySelector('[data-cj-drawer-open]');
    if (!drawer || !opener) return;
    function open() { drawer.hidden = false; opener.setAttribute('aria-expanded', 'true'); document.body.classList.add('cj-lock'); var c = drawer.querySelector('[data-cj-drawer-close].cj-iconbtn'); if (c) c.focus(); }
    function close() { drawer.hidden = true; opener.setAttribute('aria-expanded', 'false'); document.body.classList.remove('cj-lock'); opener.focus(); }
    opener.addEventListener('click', open);
    drawer.querySelectorAll('[data-cj-drawer-close]').forEach(function (el) { el.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !drawer.hidden) close(); });
  }

  /* ---------- Footer accordions closed on mobile ---------- */
  function initFooter() {
    if (window.matchMedia('(max-width: 989px)').matches) {
      document.querySelectorAll('.cj-footer__menu').forEach(function (d) { d.removeAttribute('open'); });
    }
  }

  /* ---------- Tabs ---------- */
  function initTabs(root) {
    var tabs = root.querySelectorAll('[data-cj-tab]');
    function select(name, focus) {
      tabs.forEach(function (t) {
        var on = t.getAttribute('data-cj-tab') === name;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        var panel = document.getElementById(t.getAttribute('aria-controls'));
        if (panel) panel.hidden = !on;
        if (on && focus) t.focus();
      });
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { select(t.getAttribute('data-cj-tab')); });
      t.addEventListener('keydown', function (e) {
        var dir = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
        if (!dir) return;
        var next = tabs[(i + dir + tabs.length) % tabs.length];
        select(next.getAttribute('data-cj-tab'), true);
      });
    });
    document.querySelectorAll('[data-cj-open-tab]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        select(a.getAttribute('data-cj-open-tab'));
        root.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  /* ---------- Product page ---------- */
  function money(cents, symbol) {
    return symbol + (cents / 100).toFixed(2);
  }
  function initProduct(root) {
    var jsonEl = root.querySelector('[data-cj-product-json]');
    if (!jsonEl) return;
    var data = JSON.parse(jsonEl.textContent);
    var ci = data.colourIndex, si = data.sizeIndex;
    var mult = 1 + (data.vatRate || 0) / 100;
    var form = root.querySelector('[data-cj-form]');
    var addBtn = root.querySelector('[data-cj-add]');
    var addLabel = root.querySelector('[data-cj-add-label]');
    var errorEl = root.querySelector('[data-cj-error]');
    var mainImg = root.querySelector('.cj-gallery__main img');
    var unitEl = root.querySelector('[data-cj-unit-price]');
    var skuEl = root.querySelector('[data-cj-sku]');
    var colourLabel = root.querySelector('[data-cj-colour-label]');
    var hiddenId = root.querySelector('[data-cj-variant-id]');
    var initialId = hiddenId ? parseInt(hiddenId.value, 10) : null;
    var initial = data.variants.filter(function (v) { return v.id === initialId; })[0] || data.variants[0];
    var state = { colour: ci >= 0 ? initial.options[ci] : null, others: {} };
    initial.options.forEach(function (val, idx) { if (idx !== ci && idx !== si) state.others[idx] = val; });

    function exInc(cents) {
      return data.pricesIncludeVat ? { ex: Math.round(cents / mult), inc: cents } : { ex: cents, inc: Math.round(cents * mult) };
    }
    function vatMode() { return document.documentElement.getAttribute('data-vat') === 'inc' ? 'inc' : 'ex'; }

    function matches(v, size) {
      for (var i = 0; i < v.options.length; i++) {
        if (i === ci && v.options[i] !== state.colour) return false;
        if (i === si) { if (size != null && v.options[i] !== size) return false; continue; }
        if (i !== ci && state.others[i] != null && v.options[i] !== state.others[i]) return false;
      }
      return true;
    }
    function variantFor(size) {
      return data.variants.filter(function (v) { return matches(v, size); })[0] || null;
    }

    function lines() {
      var out = [];
      if (si >= 0) {
        root.querySelectorAll('[data-cj-size]').forEach(function (cell) {
          var q = parseInt(cell.querySelector('[data-cj-qty]').value, 10) || 0;
          var v = variantFor(cell.getAttribute('data-cj-size'));
          if (q > 0 && v && v.available) out.push({ variant: v, quantity: q });
        });
      } else {
        var single = root.querySelector('[data-cj-qty-single]');
        var v = variantFor(null);
        var q = single ? parseInt(single.value, 10) || 0 : 1;
        if (v && q > 0) out.push({ variant: v, quantity: q });
      }
      return out;
    }

    function refresh() {
      // size cells availability
      var firstVariant = null;
      root.querySelectorAll('[data-cj-size]').forEach(function (cell) {
        var v = variantFor(cell.getAttribute('data-cj-size'));
        var input = cell.querySelector('[data-cj-qty]');
        var note = cell.querySelector('[data-cj-size-note]');
        var ok = v && v.available;
        cell.classList.toggle('is-disabled', !ok);
        input.disabled = !ok;
        if (!ok) input.value = 0;
        note.textContent = !v ? 'N/A' : (v.available ? '' : 'Sold out');
        cell.classList.toggle('is-filled', (parseInt(input.value, 10) || 0) > 0);
        if (!firstVariant && v) firstVariant = v;
      });
      var shown = firstVariant || variantFor(null) || initial;
      if (hiddenId && shown) hiddenId.value = shown.id;
      if (skuEl && shown && shown.sku) skuEl.textContent = shown.sku;
      if (shown && shown.image && mainImg) { mainImg.src = shown.image; mainImg.removeAttribute('srcset'); }
      if (unitEl && shown) {
        var p = exInc(shown.price);
        unitEl.querySelectorAll('.cj-only-ex.cj-price__main').forEach(function (el) { el.textContent = money(p.ex, data.currency); });
        unitEl.querySelectorAll('.cj-only-inc.cj-price__main').forEach(function (el) { el.textContent = money(p.inc, data.currency); });
        unitEl.querySelectorAll('.cj-only-ex.cj-price__sub').forEach(function (el) { el.textContent = 'ex VAT · ' + money(p.inc, data.currency) + ' inc VAT'; });
        unitEl.querySelectorAll('.cj-only-inc.cj-price__sub').forEach(function (el) { el.textContent = 'inc VAT · ' + money(p.ex, data.currency) + ' ex VAT'; });
      }
      // button label
      if (!addBtn || !addLabel) return;
      var ls = lines();
      var qty = 0, total = 0;
      ls.forEach(function (l) { qty += l.quantity; total += l.variant.price * l.quantity; });
      if (qty === 0) {
        addLabel.textContent = si >= 0 ? 'Choose sizes above' : 'Add to basket';
        addBtn.disabled = si >= 0;
      } else {
        var t = exInc(total);
        var mode = vatMode();
        addLabel.textContent = 'Add ' + qty + ' to basket · ' + money(t[mode], data.currency) + (mode === 'inc' ? ' inc VAT' : ' ex VAT');
        addBtn.disabled = false;
      }
    }

    root.querySelectorAll('[data-cj-colour]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.colour = btn.getAttribute('data-cj-colour');
        root.querySelectorAll('[data-cj-colour]').forEach(function (b) {
          var on = b === btn;
          b.classList.toggle('is-active', on);
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        if (colourLabel) colourLabel.textContent = state.colour;
        refresh();
      });
    });
    root.querySelectorAll('[data-cj-other]').forEach(function (sel) {
      sel.addEventListener('change', function () { state.others[parseInt(sel.getAttribute('data-cj-other'), 10)] = sel.value; refresh(); });
    });
    root.addEventListener('input', function (e) { if (e.target.matches('[data-cj-qty], [data-cj-qty-single]')) refresh(); });
    var box = root.querySelector('[data-cj-brandbox]');
    var mail = root.querySelector('[data-cj-quote-mail]');
    function updateMail() {
      if (!box || !mail) return;
      var methods = [];
      root.querySelectorAll('[data-cj-branding]:checked').forEach(function (c) { methods.push(c.value); });
      var sizes = [];
      lines().forEach(function (l) { sizes.push(l.quantity + ' x ' + l.variant.options.join(' / ')); });
      var body = 'Hi Cooper & James,\n\nPlease can you price branding for:\n\nProduct: ' + box.getAttribute('data-product-title') +
        '\nLink: ' + box.getAttribute('data-product-url') +
        (state.colour ? '\nColour: ' + state.colour : '') +
        (sizes.length ? '\nQuantities: ' + sizes.join(', ') : '\nQuantity: ') +
        '\nBranding method: ' + (methods.length ? methods.join(', ') : '') +
        '\n\nI have attached my logo.\n\nName:\nCompany:\nPhone:\n';
      mail.href = 'mailto:' + mail.getAttribute('data-email') + '?subject=' + encodeURIComponent('Branding price: ' + box.getAttribute('data-product-title')) + '&body=' + encodeURIComponent(body);
    }
    root.addEventListener('change', updateMail);
    root.addEventListener('input', updateMail);
    root.addEventListener('click', function (e) { if (e.target.closest('[data-cj-colour]')) setTimeout(updateMail, 0); });
    updateMail();
    document.addEventListener('cj:vat', refresh);

    root.querySelectorAll('[data-cj-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        if (mainImg) { mainImg.src = thumb.getAttribute('data-cj-thumb'); mainImg.removeAttribute('srcset'); }
        root.querySelectorAll('[data-cj-thumb]').forEach(function (t) { t.classList.toggle('is-active', t === thumb); });
      });
    });

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var ls = lines();
        if (!ls.length) { showError('Please enter a quantity for at least one size.'); return; }
        var branding = [];
        root.querySelectorAll('[data-cj-branding]:checked').forEach(function (c) { branding.push(c.value); });
        var items = ls.map(function (l) {
          var item = { id: l.variant.id, quantity: l.quantity };
          if (branding.length) item.properties = { Branding: branding.join(', ') + (root.querySelector('[data-cj-quote-mail]') ? ' (price to be confirmed)' : '') };
          return item;
        });
        addBtn.disabled = true;
        showError('');
        fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items })
        }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
          .then(function (res) {
            if (!res.ok) { showError(res.body.description || res.body.message || 'Sorry, something went wrong. Please try again.'); addBtn.disabled = false; return; }
            window.location.href = (window.routes && window.routes.cart_url) || '/cart';
          })
          .catch(function () { showError('Sorry, something went wrong. Please try again.'); addBtn.disabled = false; });
      });
    }
    function showError(msg) {
      if (!errorEl) return;
      errorEl.textContent = msg;
      errorEl.hidden = !msg;
    }

    refresh();
  }


  /* ---------- Our Work lightbox ---------- */
  function initGallery(root) {
    var dlg = root.querySelector('[data-cj-lightbox]');
    if (!dlg) return;
    var img = dlg.querySelector('[data-cj-lb-img]');
    var tEl = dlg.querySelector('[data-cj-lb-title]');
    var lEl = dlg.querySelector('[data-cj-lb-label]');
    var pEl = dlg.querySelector('[data-cj-lb-pos]');
    var prev = dlg.querySelector('[data-cj-lb-prev]');
    var next = dlg.querySelector('[data-cj-lb-next]');
    var photos = [], i = 0, opener = null;
    function show() {
      var p = photos[i];
      img.src = p.src; img.alt = p.alt || '';
      pEl.textContent = photos.length > 1 ? (i + 1) + ' / ' + photos.length : '';
      prev.hidden = next.hidden = photos.length < 2;
    }
    function open(btn) {
      try { photos = JSON.parse(btn.getAttribute('data-photos')) || []; } catch (e) { photos = []; }
      if (!photos.length) return;
      opener = btn; i = 0;
      tEl.textContent = btn.getAttribute('data-title') || '';
      lEl.textContent = btn.getAttribute('data-label') ? '· ' + btn.getAttribute('data-label') : '';
      show();
      if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', '');
      document.body.classList.add('cj-lock');
    }
    function close() {
      if (dlg.close) dlg.close(); else dlg.removeAttribute('open');
    }
    dlg.addEventListener('close', function () { document.body.classList.remove('cj-lock'); if (opener) opener.focus(); });
    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-cj-open-job]');
      if (btn) open(btn);
    });
    dlg.querySelector('[data-cj-lb-close]').addEventListener('click', close);
    prev.addEventListener('click', function () { i = (i - 1 + photos.length) % photos.length; show(); });
    next.addEventListener('click', function () { i = (i + 1) % photos.length; show(); });
    dlg.addEventListener('click', function (e) { if (e.target === dlg) close(); });
    dlg.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') prev.click();
      if (e.key === 'ArrowRight') next.click();
    });
  }

  function init() {
    initMega();
    initDrawer();
    initFooter();
    setVat(getVat());
    document.querySelectorAll('[data-cj-product]').forEach(initProduct);
    document.querySelectorAll('[data-cj-tabs]').forEach(initTabs);
    document.querySelectorAll('[data-cj-gallery]').forEach(initGallery);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
